// extracted by mini-css-extract-plugin
module.exports = {"wrap":"text_wrap__2VAyK","wrapSmall":"text_wrapSmall__35cei"};